import { ensureNativeModulesAreInstalled } from './ensureNativeModulesAreInstalled';
ensureNativeModulesAreInstalled();
export default globalThis.expo.SharedObject;
//# sourceMappingURL=SharedObject.js.map